import React from "react";
import "./UiAccordion.css";
import UiIcon from "../UiIcon";
import { ICON } from "../../../assets";

const UiAccordion = ({
  headerLabel,
  renderAccordionBodyContent,
  isActive = false,
  onClick = () => {},
  ...props
}) => {
  function renderAccordionHeaderContent() {
    return (
      <React.Fragment>
        <span>{headerLabel}</span>
        <span className="accordion__icon">
          <UiIcon
            size="md"
            icon={isActive ? ICON.arrowDownIcon : ICON.arrowUpIcon}
            alt="arrow"
          />
        </span>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div
        className={`accordion__item ${
          isActive ? "accordion__item--active" : ""
        }`}
        {...props}
      >
        <div
          className="accordion__header"
          onClick={onClick}
          aria-expanded={isActive}
        >
          {renderAccordionHeaderContent()}
        </div>
        <div className="accordion__body">{renderAccordionBodyContent}</div>
      </div>
    </React.Fragment>
  );
};

export default UiAccordion;
